import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_EB_SURVEY_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const EbSurveyReport = lazy(() =>
  import('../../../screens/EbSurveyReport')
    .then(module => ({default: module.EbSurveyReport})));

const EbSurveyReportNavigation = [
  {
    path: ROUTE_EB_SURVEY_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EbSurveyReport />
      </Suspense>
    ),
  },
];

export default EbSurveyReportNavigation;
